import { AxiosInstance, AxiosResponse } from "axios";
import { ApiResponse } from "../public-types";
import { ApiPath } from "..";
import { ProductApplicationModel } from "./product-types";

/**RPP31. 이용 신청서 양식 상세 */
export const getProductApplicationFormAsync = async (
  axios: AxiosInstance,
  params?: {
    productId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ applicationForm: ProductApplicationModel }>>> => {
  return await axios.get(`${ApiPath.product.application.replace("{productId}", String(params?.productId))}`);
};

/**RPP32. 이용 신청서 양식 등록/수정 */
export const postProductApplicationAsync = async (
  axios: AxiosInstance,
  params?: ProductApplicationModel,
): Promise<AxiosResponse<ApiResponse<{ content: boolean }>>> => {
  const productId = params?.productId;

  return await axios.post(`${ApiPath.product.application.replace("{productId}", String(productId))}`, {
    applicationForm: { formData: params?.formData },
  });
};
